module.exports = __webpack_public_path__ + "img/23.5422961f.svg";